export default "__VITE_ASSET__BhXP6Dfk__"